<template>
  <div id="users_upload">
    <div class="users_uploadseach">
      <el-input
        class="users_uploadseachinput"
        placeholder="请输入内容"
        v-model="uploadseach"
        clearable>
      </el-input>
      <el-button>查找</el-button>
      <el-button>全部</el-button>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane label="展示中">
        <uploadtables :tableData="tableData"></uploadtables>
      </el-tab-pane>
      <el-tab-pane label="审核中">
        <uploadtables :tableData="tableData"></uploadtables>
      </el-tab-pane>
      <el-tab-pane label="未通过">
        <uploadtables :tableData="tableData"></uploadtables>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
const uploadtables = ()=>import('components/content/tables/uploadtables.vue')

export default {
  name:'users_upload',
  data() {
    return {
      uploadseach:'',
      tableData: []
    }
  },
  components:{
    uploadtables
  },
  methods: {
    
  },
  beforeRouteEnter(to,from,next){
    next(vm=>{
      if(!vm.$store.state.username){
        vm.$router.push('/home')
        vm.$store.state.reg_logVisible = true
      }
    })
  }
}
</script>

<style>
#users_upload{
  flex: 1;
  overflow-y: scroll;
  background-color: rgb(240, 240, 240);
  padding: 20px 35px;
}
.users_uploadseach{
  margin: 10px 0;
  display: flex;
}
.users_uploadseachinput{
  width: 300px;
  margin-right: 10px;
}
</style>